import * as React from 'react';

import ContentBanner from '../../modules/content-banner';

interface IBaseScreenProps {}

const BaseScreen: React.FC<IBaseScreenProps> = props => {
    return (
        <>
            <ContentBanner />
            {props.children}
        </>
    );
};

export default BaseScreen;
